import {
  DialogActions,
  InputAdornment,
  MuiThemeProvider,
} from "@material-ui/core";
import {
  CircularProgress,
  Dialog,
  IconButton,
  TextField,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/SearchOutlined";
import closeLogo from "../../assets/img/closeIcon.svg";
import React from "react";
import SingleEntryRow from "./SingleEntryRow";
import { useState } from "react";
import { useEffect } from "react";
import { getClassInfo } from "../../utils/authentication-access";
import BaseService from "../../store/services/base.service";
import { CLASSES } from "../../utils";
import classes from "./Scheduler.module.css";

function StartLivePopup(props) {
  const [boards, setBoards] = useState([]);
  const [filteredBoards, setFilteredBoards] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchFieldBtn, setSearchFieldBtn] = useState(false);

  useEffect(() => {
    if (props.showLiveClassPopup) {
      const classes = JSON.parse(localStorage.getItem("classes"));
      classes.forEach(async (classInfo) => {
        const url = CLASSES.fetchClass(classInfo.kneuraId);
        const res = await new BaseService().makeGetRequestGeneric(url);
        if (res.data.iwbMetaData.length) {
          setBoards([...res.data.iwbMetaData, ...boards]);
          setFilteredBoards([...res.data.iwbMetaData, ...filteredBoards]);
        }
      });
    } else {
      setBoards([]);
      setFilteredBoards([]);
    }
  }, [props.showLiveClassPopup]);

  return (
    <MuiThemeProvider>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        className="overlay"
        open={props.showLiveClassPopup}
        onClose={props.closeLiveClassPopup}
        bodyStyle={{ padding: "unset" }}
      >
        <div className="dialog-modal-header bg-primary">
          <div />
          <div className="text-center">
            <img
              className="close-icon hover"
              src={closeLogo}
              alt="Close"
              style={{ visibility: "hidden" }}
            />
          </div>
        </div>
        <div className="modal-card">
          <div className="modal-title">{"Start a Live Class"}</div>
          {/* <div className="modal-subtitle" style={{ justifySelf: "center" }}>
            {"Searching for current live classes"}
          </div> */}
          <TextField
            id="LPsearch"
            variant="outlined"
            placeholder={"Search name..."}
            className={classes.SearchField}
            value={searchText}
            onChange={(event) => {
              setSearchText(event.target.value);
              if (event.target.value)
                setFilteredBoards(
                  filteredBoards.filter(function (item) {
                    return (
                      item.name
                        .toLowerCase()
                        .indexOf(event.target.value.toLowerCase()) !== -1
                    );
                  }),
                );
              else setFilteredBoards(boards);
            }}
            onClick={() => {
              setSearchFieldBtn(true);
            }}
            fullWidth
            InputProps={{
              autoComplete: "off",
              endAdornment: (
                <InputAdornment position="end">
                  {searchFieldBtn && searchText ? (
                    <IconButton
                      size="small"
                      onClick={() => {
                        // setSearchText("");
                        // setSearchFieldBtn(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : (
                    <SearchIcon style={{ color: "#BFC7D2" }} />
                  )}
                </InputAdornment>
              ),
              style: { height: 40, width: "100%" },
            }}
          />
          {/* <CircularProgress
            size={80}
            thickness={5}
            color={"#0074E4"}
            style={{ justifySelf: "center" }}
          /> */}
          {/* <SingleEntryRow type="LIVE_CLASS" />
          <SingleEntryRow type="THIRD_PARTY" /> */}
          {/* <SingleEntryRow type={"GO_LIVE"} url={""} flowId={""} /> */}
          {filteredBoards.map((board) => (
            <SingleEntryRow
              type={"GO_LIVE"}
              url={board.url}
              flowId={board.flow_id}
              name={board.name}
            />
          ))}
          <DialogActions>
            <button
              className="btn-button-blank"
              onClick={props.closeJoinClassPopup}
            >
              {"Cancel"}
            </button>
          </DialogActions>
        </div>
      </Dialog>
    </MuiThemeProvider>
  );
}

export default StartLivePopup;
